import request from '../axios';
import { ListResponse } from '@/src/types/common';
import { Media } from '@/src/models/MeidaDto';

const URL = {
  bigImages: '/media/big-images',
  smallImages: '/media/small-images',
};

export const postMediaBigImages = async (
  requestBody: FormData,
): Promise<ListResponse<Media>> => {
  const { data } = await request<ListResponse<Media>>({
    method: 'post',
    url: URL.bigImages,
    requestBody,
  });

  const rows = data.rows;
  return { rows, count: data.count };
};
export const postMediaSmallImages = async (
  requestBody: FormData,
): Promise<ListResponse<Media>> => {
  const { data } = await request<ListResponse<Media>>({
    method: 'post',
    url: URL.smallImages,
    requestBody,
  });

  const rows = data.rows;
  return { rows, count: data.count };
};
